import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5001/api';

/**
 * Submit a bug report with optional screenshot
 */
export async function submitBugReport(
  data: { title: string; description?: string; file?: File },
  token: string
): Promise<{ success: boolean; message: string }> {
  const formData = new FormData();
  formData.append('title', data.title);
  if (data.description) {
    formData.append('description', data.description);
  }
  if (data.file) {
    formData.append('file', data.file);
  }

  const response = await axios.post(
    `${API_BASE_URL}/bug-reports`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response.data;
}
